import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from "react-redux";
import Form from "react-bootstrap/Form";
import Modal from 'react-bootstrap/Modal';
import Button from "react-bootstrap/Button";
import * as Yup from 'yup';
import { Formik } from 'formik';
import { updatePassword, user, getUser, status } from "../../reducers/users";
import AddressModal from "../modals/AddressModal";
import BalanceModal from "../modals/BalanceModal";
import RoleModal from "../modals/RoleModal";
import UserSubsiteModal from "../modals/UserSubsiteModal";
import { useParams, useLocation } from "react-router-dom";
import { PersonCircle, Person, Sliders, Lock, Diagram2, CashCoin, Envelope, GeoAltFill, BagFill, PersonFill, PersonFillExclamation, Pencil } from 'react-bootstrap-icons';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import UserService from "../../services/user.service";
import NameModal from "../modals/NameModal";
import UsernameEmailModal from "../modals/UsernameEmailModal";

const UserDetails = () => {
  const { userId } = useParams();
  console.log("USAER ID", userId);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  //  const userProfile = useSelector(user);
  const [passwordModalShow, setPasswordModalShow] = useState(false);
  const [addressModalShow, setAddressModalShow] = useState(false);
  const [balanceModalShow, setBalanceModalShow] = useState(false);
  const [rolesModalShow, setRolesModalShow] = useState(false);
  const [subsiteModalShow, setSubsiteModalShow] = useState(false);
  const [nameModalShow, setNameModalShow] = useState(false);
  const [usernameEmailModalShow, setUsernameEmailModalShow] = useState(false);
  const [emailSent, setEmailSent] = useState(false);
  const location = useLocation();
  let userProfile = useSelector(user);
  const { isAdmin, isSuperAdmin, isSupervisor, loading } = useSelector(state => state.auth);

  const loadingUserStatus = useSelector(status);


  useEffect(() => {
    if (loadingUserStatus === 'idle') {
      dispatch(getUser(userId));
    }
  }, [loadingUserStatus, dispatch]);

  useEffect(() => {
    dispatch(getUser(userId));
  }, [userId, dispatch]);

  const handlePasswordClick = (values, { setSubmitting, resetForm }) => {
    //setSubmitting(true);

    dispatch(updatePassword(values));

    setPasswordModalShow(false);

  }

  const showPasswordModal = () => {
    setPasswordModalShow(true);
  }

  const passwordModalClose = () => {
    setPasswordModalShow(false);
  }

  const closeAddressModal = () => {
    setAddressModalShow(false);
  }
  const showAddressModal = () => {
    setAddressModalShow(true);
  }

  const closeBalanceModal = () => {
    setBalanceModalShow(false);
    dispatch(getUser(userId));
  }
  const showBalanceModal = () => {
    setBalanceModalShow(true);
  }

  const closeRolesModal = () => {
    setRolesModalShow(false);
  }
  const showRolesModal = () => {
    setRolesModalShow(true);
  }
  const closeSubsiteModal = () => {
    setSubsiteModalShow(false);
  }
  const showSubsiteModal = () => {
    setSubsiteModalShow(true);
  }

  const deactivateUser = async () => {
    var status = await UserService.deactivateUser(userProfile.id);
    if (status.error) {
      alert("Error deactivating user:" + status.message);
    } else {
      dispatch(getUser(userId));
    }
  }

  const reactivateUser = async () => {
    var status = await UserService.reactivateUser(userProfile.id);
    if (status.error) {
      alert("Error reactivating user:" + status.message);
    } else {
      dispatch(getUser(userId));
    }
  }

  const sendRegistrationEmail = async () => {
    var status = await UserService.sendUnregisteredEmail(userProfile.id);
    if (status.error) {
      setEmailSent(status.error);
    } else {
      setEmailSent("Email Sent");
    }
  }
  // Schema for yup
  const validationSchema = Yup.object().shape({
    currentPassword: Yup.string()
      .required("*Password is required"),
    newPassword: Yup.string()
      .min(8, "*Passwords must be 8 characters")
      .max(100, "*Passwords can't be longer than 100 characters")
      .required("*New Password is required"),
    confirmNewPassword: Yup.string()
      .oneOf([Yup.ref('newPassword'), null], 'Passwords must match')
  });

  // Schema for yup
  const addressValidationSchema = Yup.object().shape({
    street: Yup.string()
      .required("*Street is required"),
    city: Yup.string()
      .required("*City is required"),
    state: Yup.string()
      .required("*State is required"),
    zip: Yup.string()
      .required("*Zip Code is required")
      .min(5, "*Zip Code must be at least 5 digits")
      .max(10, "*Zip Code can't be more than 10 digits"),
  });
  if (!userProfile || JSON.stringify(userProfile) === '{}') {
    return (
      <div>Loading...</div>
    );
  } else {
    console.log("USER PROFILE", userProfile, loadingUserStatus);
    return (
      <div className="user-details-container">
        <Container className="user-data">
          <Row>
            <Col className="icon">
              {userProfile.registration_id || !userProfile.active ? <PersonFillExclamation size={60} color={"#990000"} /> : <PersonCircle size={60} color={"#009900"} />}
              <Col className="header">{userProfile?.firstname} {userProfile?.lastname} &nbsp;
                <Pencil size={20} onClick={() => setNameModalShow(true)} />
              </Col>
            </Col>
          </Row>
          <Row>
            <Col>
              <hr />
            </Col>
          </Row>
          <Row>
            <Col className="icon">
              <Sliders size={40} />
            </Col>
          </Row>
          <Row>
            <Col className="title" xs={3}>Status</Col>
            <Col className="value">
              {userProfile.registration_id ?
                <Row>
                  <Col className="icon" style={{ color: "#990000" }}>
                    This user has not yet completed registration.
                  </Col>
                  <Col>
                    <Button onClick={() => sendRegistrationEmail(userProfile.id)}>Resend Registration Email</Button>
                    {emailSent && <div>{emailSent}</div>}
                  </Col>
                </Row>
                :
                <Row>
                  <Col className="icon" style={{ color: "#009900" }}>
                    This user completed registration.
                  </Col>
                </Row>
              }
              {!userProfile?.active ? (
                <Row>
                  <Col className="icon" style={{ color: "#990000" }}>
                    This user is Inactive. Inactive users cannot login, but their orders will remain in the system.<br />
                    <Button onClick={reactivateUser}>Reactivate User</Button>
                  </Col>
                </Row>
              ) : (
                <Row>
                  <Col className="icon">
                    Inactive users cannot login, but their orders will remain in the system.<br />
                    <Button onClick={deactivateUser}>Deactivate User</Button>
                  </Col>
                </Row>

              )}

            </Col>
          </Row>

          <Row>
            <Col>
              <hr />
            </Col>
          </Row>
          <Row>
            <Col className="icon">
              <Person size={40} />
            </Col>
          </Row>
          <Row>
            <Col className="title" xs={3}>Username</Col>
            <Col className="value">{userProfile?.email}<Pencil size={20} onClick={() => setUsernameEmailModalShow(true)} />
            </Col>
          </Row>
          <Row>
            <Col>
              <hr />
            </Col>
          </Row>
          <Row>
            <Col className="icon">
              <Envelope size={40} />
            </Col>
          </Row>
          <Row>
            <Col className="title" xs={3}>Email Address</Col>
            <Col className="value">{userProfile?.email}<Pencil size={20} onClick={() => setUsernameEmailModalShow(true)} />
            </Col>
          </Row>
          <Row>
            <Col>
              <hr />
            </Col>
          </Row>
          <Row>
            <Col className="icon">
              <GeoAltFill size={40} />
            </Col>
          </Row>
          <Row>
            <Col className="title" xs={3}>Address</Col>
            <Col className="value">{userProfile?.street}<br />
              {userProfile?.street2 !== "" ? <>{userProfile?.street2}<br /></> : null}
              {userProfile?.city}, {userProfile?.state} {userProfile?.zip}<br /><br />
              <Button size="sm" variant="outline-secondary" onClick={showAddressModal}>Update Address</Button>
            </Col>
          </Row>
          <Row>
            <Col>
              <hr />
            </Col>
          </Row>
          <Row>
            <Col className="icon">
              <Lock size={40} />
            </Col>
          </Row>
          <Row>
            <Col className="title" xs={3}>Password</Col>
            <Col className="value">
              <Button size="sm" variant="outline-secondary" onClick={showPasswordModal}>Reset Password</Button>
            </Col>
          </Row>
          <Row>
            <Col>
              <hr />
            </Col>
          </Row>
          <Row>
            <Col className="icon">
              <CashCoin size={40} />
            </Col>
          </Row>
            <Row>
              <Col className="title" xs={3}>Roles</Col>
              <Col className="value">
                <ul>
                  {userProfile?.roles?.map(role => {

                    if (role.roleName === "siteadmin")
                      return (
                        <li>Site Admin</li>
                      );
                    else if (role.roleName === "user")
                      return (
                        <li>User</li>
                      );
                    else if (role.roleName === "super")
                      return (
                        <li>Super User</li>
                      );
                    else
                      return (
                        <li>{role}</li>
                      );
                  })}
                </ul>
                {(isAdmin || isSuperAdmin) && (
                <Button size="sm" variant="outline-secondary" onClick={showRolesModal}>Update Roles</Button>
                )}
              </Col>
            </Row>
              <Row>
                <Col>
                  <hr />
                </Col>
              </Row>
          {(isAdmin || isSuperAdmin) && (
            <><Row>
              <Col className="icon">
                <CashCoin size={40} />
              </Col>
            </Row>
              <Row>
                <Col className="title" xs={3}>Balance</Col>
                <Col className="value">
                  <p>${userProfile?.subsiteBalance?.balance ? userProfile?.subsiteBalance?.balance : 0}</p>
                  <p><Button size="sm" variant="outline-secondary" onClick={showBalanceModal}>Update Balance</Button></p>
                  <p><input type="checkbox" id="rollover" name="rollover" onChange={(e) => UserService.updateBalanceRollsOver({ userId: userProfile.id, balanceRollsOver: e.target.checked })} checked={userProfile?.subsiteBalance?.balanceRollsOver} /> Balance Rolls Over</p>
                </Col>
              </Row>
              <Row>
                <Col>
                  <hr />
                </Col>
              </Row>
            </>
          )}
          {isSuperAdmin &&
            <>
              <Row>
                <Col className="icon">
                  <Diagram2 size={40} />
                </Col>
              </Row>
              <Row>
                <Col className="title" xs={3}>Subsites</Col>
                <Col className="value">
                  {userProfile?.subsites?.map(subsite => {
                    return (
                      <div>{subsite.subsiteName}</div>
                    );
                  })}<br /><br />
                  <Button size="sm" variant="outline-secondary" onClick={showSubsiteModal}>Update Subsites</Button>
                </Col>
              </Row>
              <Row>
                <Col>
                  <hr />
                </Col>
              </Row>

            </>
          }
          <Row>
            <Col className="icon">
              <BagFill size={40} />
            </Col>
          </Row>
          <Row>
            <Col className="title" xs={3}>Orders</Col>
            <Col className="value">
              <Container>
                <Row>
                  <Col>Order Id</Col>
                  <Col>Cost</Col>
                </Row>
                {userProfile?.orders?.map(order => {
                  return (
                    <Row>
                      <Col>{order.id}</Col>
                      <Col>{order.orderCost}</Col>
                    </Row>
                  );
                })}
              </Container>
            </Col>
          </Row>

        </Container>
        {passwordModalShow && 
          <Modal show={passwordModalShow} onHide={passwordModalClose}>
            <Modal.Header closeButton>
              <Modal.Title>Update Password<br /></Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Formik
                initialValues={{ currentPassword: "", newPassword: "", confirmNewPassword: "" }}
                validationSchema={validationSchema}
                onSubmit={handlePasswordClick}
              >
                {/* Callback function containing Formik state and helpers that handle common form actions */}
                {({ values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  isSubmitting }) => (
                  <Form onSubmit={handleSubmit} >
                    <Form.Group className="mb-3" controlId="currentPassword">
                      <Form.Label>Current Password</Form.Label>
                      <Form.Control
                        name="currentPassword"
                        type="password"
                        placeholder="Current Password"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.currentPassword}
                        className={touched.currentPassword && errors.currentPassword ? "error" : null}
                      />
                      {touched.currentPassword && errors.currentPassword ? (
                        <div className="error-message">{errors.currentPassword}</div>
                      ) : null}
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="newPassword">
                      <Form.Label>New Password</Form.Label>
                      <Form.Control
                        name="newPassword"
                        type="password"
                        placeholder="New Password"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.newPassword}
                        className={touched.newPassword && errors.newPassword ? "error" : null}
                      />
                      {touched.newPassword && errors.newPassword ? (
                        <div className="error-message">{errors.newPassword}</div>
                      ) : null}
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="confirmNewPassword">
                      <Form.Label>Confirm New Password</Form.Label>
                      <Form.Control
                        name="confirmNewPassword"
                        type="password"
                        placeholder="Confirm New Password"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.confirmNewPassword}
                        className={touched.confirmNewPassword && errors.confirmNewPassword ? "error" : null}
                      />
                      {touched.confirmNewPassword && errors.confirmNewPassword ? (
                        <div className="error-message">{errors.confirmNewPassword}</div>
                      ) : null}
                    </Form.Group>
                    <Modal.Footer>
                      <Button variant="secondary" onClick={passwordModalClose}>
                        Cancel
                      </Button>
                      <Button variant="primary" onClick={handlePasswordClick} type="submit" disabled={isSubmitting}>
                        Change Password
                      </Button>
                    </Modal.Footer>
                  </Form>
                )}
              </Formik>
            </Modal.Body>
          </Modal>
        }
        {addressModalShow &&
          <AddressModal show={addressModalShow} closeAddressModal={closeAddressModal} />
        }
        {balanceModalShow &&
          <BalanceModal show={balanceModalShow} closeModal={closeBalanceModal} userId={userProfile?.id} initialBalance={userProfile?.subsiteBalance?.balance} />
        }
        {rolesModalShow &&
          <RoleModal user={userProfile} show={rolesModalShow} closeModal={closeRolesModal} />
        }
        {subsiteModalShow && isSuperAdmin && (
          <UserSubsiteModal user={userProfile} show={subsiteModalShow} closeModal={closeSubsiteModal} />
        )}
        {nameModalShow && (
          <NameModal user={userProfile} show={nameModalShow} closeNameModal={() => { dispatch(getUser(userId)); setNameModalShow(false); }} />
        )}
        {usernameEmailModalShow && (
          <UsernameEmailModal user={userProfile} show={usernameEmailModalShow} closeUsernameEmailModal={() => { dispatch(getUser(userId)); setUsernameEmailModalShow(false); }} />
        )}
      </div>
    );
  }
};
export default UserDetails; 